import { createContext, useContext } from "react";
import { UseQueryResult, useQuery } from "react-query";

export function useRelatedEntity({
  orgId,
  entityUuid,
  relation,
  direction,
  type,
}: Omit<RelatedEntityContext, "query">): RelatedEntityContext {
  const query = useQuery(
    ["entity", { orgId, entityUuid, relation, direction, type }],
    async () =>
      fetch(`/api/${orgId}/entity-related`, {
        method: "POST",
        body: JSON.stringify({ orgId, entityUuid, relation, direction, type }),
      }).then((res) => res.json()),
    {
      keepPreviousData: true,
      staleTime: 20_000,
    }
  );
  return { orgId, entityUuid, relation, direction, type, query };
}

export type RelatedEntityContext = {
  orgId: string;
  entityUuid: string;
  relation: string;
  direction?: string;
  type?: string;
  query: UseQueryResult<any>;
};

export const relatedEntityContext = createContext<RelatedEntityContext>(
  undefined as unknown as RelatedEntityContext
);

export function useRelatedEntityContext() {
  return useContext(relatedEntityContext);
}
